import {Button, Chip, Input, Option, Select, Textarea, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {getAgentRequestInfo} from "../../../services/agent/agent_request";
import {createAgentLog, createAgentLogNew, getAgentLog} from "../../../services/agent/agent_log";
import FileInput from "../../system/fileInput";
import {getProvinces} from "../../../services/province/province";
import SelectInput from "../../system/select";
import {getProvinceCities} from "../../../services/city/city";
import {trim} from "lodash/string";
import DateField from "../../system/dateField";

export function AgentsForm({
                             agentId,
                             open,
                             setOpen,
                             setLastDataRefresh,
                             gridSelectedRow,
                             setGridSelectedRow,
                             lastDataRefresh,
                             confirmationComments
                           }) {
  const handleOpen = () => setOpen(!open);

  const [agentRequest, setAgentRequest] = useState(null);
  const [newConfirmationComments, setNewConfirmationComments] = useState(confirmationComments);
  // const [agentId, setAgentId] = useState(null);
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [provinceId, setProvinceId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [homePhone, setHomePhone] = useState("")
  const [email, setEmail] = useState("")
  const [address, setAddress] = useState("")
  const [degreeId, setDegreeId] = useState("");
  const [stageDegreeId, setStageDegreeId] = useState("");
  const [experience, setExperience] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [aboutMe, setAboutMe] = useState("");
  const [degreeFile, setDegreeFile] = useState("");
  const [resumeFile, setResumeFile] = useState("");
  const [introductionFile, setIntroductionFile] = useState("");
  const [status, setStatus] = useState("");
  const [provinceTitle, setProvinceTitle] = useState("");
  const [cityTitle, setCityTitle] = useState("");
  const [degreeTitle, setDegreeTitle] = useState("");
  const [stageTitle, setStageTitle] = useState("");
  const [agentTId, setAgentTId] = useState("");


  const [id, setId] = useState(null);
  const [adminId, setAdminId] = useState(null);
  const [comment, setComment] = useState("");
  const [statusLog, setStatusLog] = useState("");
  const [agentLog, set_agent_log] = useState(null);

  const [dataGot, setDataGot] = useState(false);

  useEffect(() => {
    async function getData(id) {
      const result = await getAgentRequestInfo(id);
      if (result.status === 200) {
        const {agent_request_info} = result.data;
        setAgentRequest(agent_request_info || []);
      }
      let result_log;

      result_log = await getAgentLog(id)

      if (result_log.status === 200) {
        const {agent_log} = result_log.data;
        set_agent_log(agent_log);
        setId(agent_log.id)
        setAdminId(agent_log.admin_id)
        setComment(agent_log.comment)
        setStatusLog(agent_log.status)
        // setGridSelectedRow(false)
        // setLastDataRefresh(Date.now())
        // setAgentAccepted(true);
        // handleOpen()
      }
      setDataGot(true);
    }

    if (agentId) {
      getData(agentId);
    }
  }, [agentId]);

  useEffect(() => {
    // setAgentId((agentRequest && agentRequest.agent_id) || null);
    setName((agentRequest && agentRequest.name) || "");
    setFamily((agentRequest && agentRequest.family) || "");
    setPhone((agentRequest && agentRequest.phone) || "");
    setFatherName((agentRequest && agentRequest.father_name) || "");
    setNationalCode((agentRequest && agentRequest.national_code) || "");
    setBirthDate((agentRequest && agentRequest.birth_date) || "");
    setGender((agentRequest && agentRequest.gender) || "");
    setDegreeId((agentRequest && agentRequest.degree_id) || "");
    setStageDegreeId((agentRequest && agentRequest.stage_degree_id) || "");
    setDegreeFile((agentRequest && agentRequest.degree_file) || "");
    setHomePhone((agentRequest && agentRequest.home_phone) || "");
    setProvinceId((agentRequest && agentRequest.province_id) || "");
    setCityId((agentRequest && agentRequest.city_id) || "");
    setEmail((agentRequest && agentRequest.email) || "");
    setAddress((agentRequest && agentRequest.address) || "");
    setExperience((agentRequest && agentRequest.experience) || "");
    setSpeciality((agentRequest && agentRequest.speciality) || "");
    setAboutMe((agentRequest && agentRequest.about_me) || "");
    setResumeFile((agentRequest && agentRequest.resume_file) || "");
    setIntroductionFile((agentRequest && agentRequest.introduction_file) || "");
    setStatus((agentRequest && agentRequest.status) || "");
    setProvinceTitle((agentRequest && agentRequest.province_title) || "");
    setCityTitle((agentRequest && agentRequest.city_title) || "");
    setDegreeTitle((agentRequest && agentRequest.degree_title) || "");
    setStageTitle((agentRequest && agentRequest.stage_title) || "");
    setAgentTId((agentRequest && agentRequest.agent_tid) || "");
  }, [agentRequest])

  const save_log = async (status_action) => {
    const data = {
      agent_log: {
        agent_id: agentId,
        admin_id: adminId,
        comment: comment,
        status: status_action,
      },
      agent: {
        agent_id: parseInt(agentId),
        name: name,
        family: family,
        phone: phone,
        father_name: fatherName,
        national_code: nationalCode,
        birth_date: birthDate,
        gender: gender,
        degree_id: parseInt(degreeId),
        stage_degree_id: parseInt(stageDegreeId),
        degree_file: degreeFile,
        home_phone: homePhone,
        province_id: parseInt(provinceId),
        city_id: parseInt(cityId),
        email: email,
        address: address,
        experience: parseInt(experience),
        speciality: speciality,
        about_me: aboutMe,
        resume_file: resumeFile,
        introduction_file: introductionFile,
        status: status_action,
      },
    };
    let result;

    if (agentTId) {
      data.agent.id = parseInt(agentTId);
      result = await createAgentLog(data);
    } else {
      result = await createAgentLogNew(data);
    }

    if (result.status === 200) {
      set_agent_log(result.data);
      setLastDataRefresh(Date.now())
    }
  };

  const handleTap = (title, description) => {
    if (comment.trim() === '') {
      setComment(title + ' - ' + description);
    } else if (!comment.includes(title + ' - ' + description)) {
      setComment(trim(comment + '\n' + title + ' - ' + description));
    } else {
      setComment(trim(comment.replace(title + ' - ' + description, '')));
    }
  };

  if (dataGot) {
    return (
      <>
        <div className="grid grid-cols-1 gap-4 p-4 overflow-y-scroll max-w-full md:grid-cols-2 xxl:grid-cols-3">

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={name}
                   label={Dict('name')}
                   placeholder={Dict('name')}
                   onChange={(e) => {
                     e.target.value = name
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={family}
                   label={Dict('family')}
                   placeholder={Dict('family')}
                   onChange={(e) => {
                     e.target.value = family
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={phone}
                   label={Dict('phone')}
                   placeholder={Dict('phone')}
                   onChange={(e) => {
                     e.target.value = phone
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={fatherName}
                   label={Dict('father_name')}
                   placeholder={Dict('father_name')}
                   onChange={(e) => {
                     setFatherName(e.target.value)
                   }}
            />
          </div>

          <div className="flex w-full mt-2 mb-4">
            <Input variant="standard"
                   value={nationalCode}
                   label={Dict('national_code')}
                   placeholder={Dict('national_code')}
                   onChange={(e) => {
                     setNationalCode(e.target.value)
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <DateField
              className="my-4 mx-4 w-full"
              date={birthDate}
              setDate={setBirthDate}
              label={Dict("birth_date")}
            />
          </div>

          <div className="flex w-full mb-4">
            <Select variant="static" className="rtl" style={{label: {left: ""}}}
                    label={Dict('gender')}
                    value={gender}
                    onChange={(val) => setGender(val)}>
              <Option value="male">مرد</Option>
              <Option value="female">زن</Option>
            </Select>
          </div>

          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("province")}
              defaultValue={provinceId}
              autoLoadService={getProvinces}
              onChange={setProvinceId}
            />
          </div>

          <div className="col w-full mb-4">
            <SelectInput
              className="w-full"
              label={Dict("city")}
              defaultValue={cityId}
              refreshSignal={provinceId}
              autoLoadService={getProvinceCities}
              autoLoadServiceData={provinceId}
              onChange={setCityId}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={homePhone}
                   label={Dict('home_phone')}
                   placeholder={Dict('home_phone')}
                   onChange={(e) => {
                     setHomePhone(e.target.value)
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={email}
                   label={Dict('email')}
                   placeholder={Dict('email')}
                   onChange={(e) => {
                     setEmail(e.target.value)
                   }}
            />
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={address}
              label={Dict('address')}
              onChange={(e) => {
                setAddress(e.target.value)
              }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={degreeTitle}
                   label={Dict('degree')}
                   placeholder={Dict('degree')}
                   onChange={(e) => {
                     e.target.value = degreeTitle
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={stageTitle}
                   label={Dict('stage_degree')}
                   placeholder={Dict('stage_degree')}
                   onChange={(e) => {
                     e.target.value = stageTitle
                   }}
            />
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={address}
              label={Dict('address')}
              onChange={(e) => {
                e.target.value = address
              }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={experience}
                   label={Dict('experience')}
                   placeholder={Dict('experience')}
                   onChange={(e) => {
                     e.target.value = experience
                   }}
            />
          </div>

          <div className="col w-full mb-4">
            <Input variant="standard"
                   value={speciality}
                   label={Dict('speciality')}
                   placeholder={Dict('speciality')}
                   onChange={(e) => {
                     e.target.value = speciality
                   }}
            />
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={aboutMe}
              label={Dict('about_me')}
              onChange={(e) => {
                e.target.value = aboutMe
              }}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 p-4 mb-8 overflow-y-scroll max-w-full">

          <div className="flex w-fit mb-4 p-4 md:w-1/2">
            <FileInput
              label={Dict('degree_file')}
              fileCode={degreeFile}
              onChange={(e) => {
                setDegreeFile(e.target.files[0]);
              }}/>
          </div>

          <div className="flex w-fit mb-4 md:w-1/2">
            <FileInput
              label={Dict('resume_file')}
              fileCode={resumeFile}
              onChange={(e) => {
                setResumeFile(e.target.files[0]);
              }}/>
          </div>

          <div className="flex w-fit mb-4 md:w-1/2">
            <FileInput
              label={Dict('introduction_file')}
              fileCode={introductionFile}
              onChange={(e) => {
                setIntroductionFile(e.target.files[0]);
              }}/>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-1 mb-8 overflow-y-scroll">

          <div className="flex flex-col w-fit mb-4 md:flex-row">
            <div className="flex flex-row w-fit mb-4">
              {newConfirmationComments &&
                <Typography variant="h6">
                  توضیحات پیشفرض:
                </Typography>
              }
            </div>
            <div className="grid grid-cols-1 gap-4">
              {newConfirmationComments.map(({title, description}) => (
                <div className="flex">
                  <Chip size="sm" className="mx-2 overflow-x-hidden hover:overflow-x-visible" variant="ghost"
                        value={title + " - " + description}
                        onTap={() => {
                          handleTap(title, description)
                        }}/>
                </div>
              ))
              }
            </div>
          </div>

          <div className="flex w-full mb-4">
            <Textarea
              variant="standard"
              value={comment}
              label={Dict('comment_request')}
              onChange={(e) => {
                setComment(e.target.value)
              }}
            />
          </div>
          <div className="text-left w-full mb-4">
            {statusLog && (statusLog !== 'accepted' || statusLog === 'new') &&
              <Button className="mx-2" color="green" variant="outlined"
                      onClick={() => {
                        setStatusLog("accepted");
                        save_log('accepted')
                      }}
              >
                تایید
              </Button>
            }
            {statusLog && (statusLog === 'accepted' || statusLog === 'new') &&
              <Button className="mx-2" color="red" variant="outlined"
                      onClick={() => {
                        setStatusLog("rejected");
                        save_log('rejected')
                      }}>
                عدم‌تایید
              </Button>
            }
          </div>

        </div>
      </>
    );
  }
}